export default __webpack_public_path__ + "static/media/individual-masthead.8f9da2b5.png";